export default {
  // Login page
  Username: 'Brugernavn',
  Password: 'Kodeord',
  'Logging in, please wait': 'Logger ind, vent venligst',
  'Log in': 'Log ind',
  'Log in with single sign-on': 'Log ind med single sign-on',
  'You are being safely logged out, please wait': 'Du bliver logget ud sikkert, vent venligst',
  Back: 'Tilbage',

  // Sidebar
  Department: 'Afdeling',
  'Log out': 'Log ud',
  'Your citizens': 'Dine borgere',
  'Edit information': 'Rediger oplysninger',
  'Lock screen': 'Lås skærm',
  'Add new task': 'Opret ny opgave',

  // Group list
  'Select a group': 'Vælg en gruppe',

  // Member list
  'No name': 'Intet navn',

  // Member show
  Day: 'Dag',
  Week: 'Uge',
  'Time frame': 'Tidsramme',
  'No click in time frame': 'Intet klik i tidsramme',
  'Overdue timer': 'Overskredet timer',
  'Click in time frame': 'Klik i tidsramme',
  'Click outside time frame': 'Klik udenfor tidsramme',
  'Approved deviation': 'Godkendt afvigelse',
  'This citizen has no tasks': 'Denne borger har ingen opgaver',
  'Hide deviations': 'Skjul afvigelser',
  'Show deviations': 'Vis afvigelser',
  'Show week': 'Vis uge',
  'Show today': 'Vis i dag',
  'Approving deviation': 'Godkender afvigelse',
  'Approving deviation with note': 'Godkender afvigelse med note',
  'Deviation approved': 'Afvigelse godkendt',
  'Deviation approved with note': 'Afvigelse godkendt med note',
  'Approve deviation': 'Godkend afvigelse',
  'Note (optional)': 'Note (valgfri)',
  'Optional text': 'Valgfri tekst',
  Calendar: 'Kalender',
  Appearance: 'Udseende',
  Full: 'Komplet',
  Compact: 'Kompakt',

  // Member edit
  'First name': 'Fornavn',
  'Last name': 'Efternavn',
  'Save changes': 'Gem ændringer',

  // Deviation info
  Approving: 'Godkender',
  Cancel: 'Fortryd',
  Confirm: 'Bekræft',
  Approve: 'Godkend',
  'X deviations in total': '{count} afvigelser i alt',

  // Task create / edit
  Timer: 'Timer',
  Schedule: 'Skema',
  'On demand': 'Registrering',
  Braden: 'Braden',
  minutes: 'minutter',
  hour: 'time',
  hours: 'timer',
  'MAC address already in use': 'MAC adresse allerede i brug',
  'Button ID not found': 'Knap ID ikke fundet',
  'Delete task': 'Slet opgave',
  'This can not be revereted': 'Dette kan ikke fortrydes',
  Delete: 'Slet',
  Edit: 'Rediger',
  'Edit task': 'Rediger opgave',
  'Create new task': 'Opret ny opgave',
  Name: 'Navn',
  Buttons: 'Knapper',
  Type: 'Type',
  Time: 'Tidspunkt',
  'Give the task a name': 'Giv opgaven et navn',
  Continue: 'Fortsæt',
  'Enter button ID': 'Indtast knap ID',
  'Enter MAC address': 'Indtast MAC adresse',
  'Use MAC address': 'Brug MAC adresse',
  'Use button ID': 'Brug knap ID',
  'Add button': 'Tilføj knap',
  'Select a type': 'Vælg en type',
  Ok: 'Ok',
  Close: 'Luk',
  'Select time': 'Vælg tider',
  Occurrence: 'Forekomst',
  'Every day': 'Hver dag',
  'Specific weekdays': 'Specifikke ugedage',
  'Add time': 'Tilføj tid',
  'Time tolerance in minutes': 'Tidstolerance i minutter',
  'On demand requires no planning': 'Registrering kræver ingen planlægning',
  'How much time should pass between each click': 'Hvor længe skal der gå mellem hvert klik',
  'When should the timer start': 'Hvornår skal timeren starte',
  Now: 'Nu',
  'Set a time': 'Sæt en tid',
  'Enter Braden Score': 'Indtast Braden Score',
  'Add task': 'Tilføj opgave',
  Remove: 'Fjern',
  'Select days': 'Vælg dage',
  'Times can not overlap': 'Tider må ikke overlappe',
  Monday: 'Mandag',
  Tuesday: 'Tirsdag',
  Wednesday: 'Onsdag',
  Thursday: 'Torsdag',
  Friday: 'Fredag',
  Saturday: 'Lørdag',
  Sunday: 'Søndag',
  'Task added': 'Opgave tilføjet',
  'Task updated': 'Opgave opdateret',
  'Task deleted': 'Opgave slettet',
  'Changes saved': 'Ændringer gemt',
  'Allow clicks outside of schedule?': 'Tillad klik udenfor skema?',
  'Confirm time tolerance': 'Bekræft tidstolerance',
  'Is the current time tolerance of X minutes correct?': 'Er tidstolerancen på {time} minutter korrekt?',

  // Locked screen: Ecrã bloqueado
  'You should complete the task {{task}} in {{time}}': 'Du skal udføre opgaven {{task}} om {{time}}',
  'You should complete the task {{task}} within {{time}}': 'Du skal udføre opgaven {{task}} indenfor {{time}}',
  'You should complete the task {{task}} now': 'Du skal udføre opgaven {{task}} nu',
  'The task {{task}} is overdue by {{time}}, complete as soon as possible': 'Opgaven {{task}} er overskredet med {{time}}, fuldfør hurtigst muligt',
  'Remember to complete the task {{task}} in {{time}}': 'Husk at udføre opgaven {{task}} om {{time}}',

  'Citizen-screen': 'Borger skærm',
  'Add new Citizen': 'Tilføj ny borger',
  'Or choose Citizen from list': 'Eller vælg en borger fra listen',
  'It is time to': 'Det er tid til',
  'Nothing to do - Good job!': 'Alt i orden - Godt klaret!',
  'Within the next minutes you need to remember {{task}} it would be best to do at {{time}}': 'Indenfor kort tid skal du udføre {{task}} det vil være bedst at udføre kl. {{time}}',
  "It's time to {{task}}": 'Det er tid til at udføre opgaven {{task}}',
  Version: 'Version',
  'Sharing of your location is needed to use the app correctly': 'Din lokation skal deles for at bruge applikationen korrekt',

  // MarkerInfoModal
  Fulfilled: 'Fuldført',
  Deviation: 'Afvigelse',
  'Approved by': 'Godkendt af',
  'Note by': 'Note af',
  'Add note': 'Tilføj note',
  Note: 'Note',
  'Adding note': 'Tilføjer note',

  // Notifications
  Notifications: 'Notifikationer',
  'Phone numbers': 'Telefonnumre',
  'Phone number': 'Telefonnummer',
  'Deactivate all': 'Deaktiver alle',
  'New number': 'Nyt nummer',
  Active: 'Aktiv',
  Inactive: 'Inaktiv',
  Activate: 'Aktiver',
  Deactivate: 'Deaktiver',
  'Edit number': 'Rediger nummer',
  'Add number': 'Tilføj nummer',
  'Plan type': 'Plan type',
  Simple: 'Simpel',
  Advanced: 'Avanceret',
  'Simple plan explainer': 'Den simple plan-type, gælder for udvalgte dage, mellem to tidspunkter, f.eks. hver dag fra 08:00 - 16:00',
  'Choose time': 'Vælg tid',
  From: 'Fra',
  To: 'Til',
  Create: 'Opret',
  'Advanced plan explainer': 'Den avancerede plan-type, tillader opsætning for alle ugens dage, og tillader flere tider om dagen.',
  Times: 'Tider',
  'Phone number is required': 'Telefonnummeret er påkrævet',
  'Phone number is invalid': 'Telefonnummeret er ugyldigt',
  'Active for notifications': 'Aktiv for notifikationer',
  'Toggle task notifications': 'Skift opgave notifikationer',
  'Put on pause': 'Sæt på pause',
  'Sort by deviations': 'Sorter efter afvigelser',
  'Sort by name': 'Sorter efter navn',
  Sort: 'Sorter',
  'Your active citizens': 'Dine aktive borgere',
  'Your inactive citizens': 'Dine inaktive borgere',
};
